module.exports = __webpack_public_path__ + "assets/players-inactive.76b78a45.svg";